import { Center, Text } from "@chakra-ui/react";

export default function SongcardDescription() {
  return (
    <>
      <Center>
        <Text fontSize="xl" maxW={"sm"} mb={10} mt={0} textAlign={"center"}>
          A songcard is a digital music collectable.
          <br />
          <br />
          Think of it as a <b>deluxe edition single.</b> <br />
          <br />
          It{`’`}s a way for artists to turn a song into a unique digital
          experience. <br />
          <br />
          Not only do they unlock MP3 and WAV downloads of the song, but
          collectors can access all manner of exclusive material offered by the
          songcard.
          <br />
          <br />
          Some artists have included items such as lyric sheets, desktop
          wallpapers, and behind-the-scenes footage.
          <br /> <br />
          Songcards is a new format for digital music, aiming at providing fans
          a way to unlock experiences offered by their favourite musicians.
          <br />
        </Text>
      </Center>
    </>
  );
}
